import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Content = styled.div`
    height:97%;
    width:100%;
    display: flex;
    padding-right: 4px;
    flex-direction: column;
    gap:10px;
    overflow-y: auto;
    position: relative;
    z-index: 1;
    margin-top: 1rem;
    margin-bottom: 1rem;

    ::-webkit-scrollbar{
        width:8px;
        height:100%;
        background:#dfdfdf4e;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb{
        background:#dfdfdf;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-track{
        
    } 
    
`;

export const MissingContentet = styled.div`
    display:flex;
    align-items: flex-end;
    justify-content: center;
    height:40vh;
    width:100%;
    grid-column: 1 / 5;
    min-height: max-content;
    span{
        font-weight: 500;
        font-size: 22px;
        color: #5e5e5e;
    }
`;